<template>
  <LayoutSite>
    <Formulario :titulo="Mensagem">
      <v-col cols="3">
        <v-autocomplete
          label="Usuário"
          v-model="responsavel_id"
          :items="usuarios"
          item-text="name"
          item-value="id"
          v-if="isAdmin"
          @blur="Pesquisar()"
        ></v-autocomplete>
      </v-col>
      <v-card flat>
        <v-tabs v-model="tab" centered>
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#tabAtrasados">Atrasados</v-tab>
          <v-tab href="#tabHoje">Hoje</v-tab>
          <v-tab href="#tabAmanha">Amanhã</v-tab>
          <v-tab href="#tabFuturos">Futuros</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item key="1" value="tabAtrasados">
            <v-card-title>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-text-field v-model="searchAtrasados" append-icon="mdi-magnify" label="Pesquisar"></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="itemsAtrasados"
              :search="searchAtrasados"
              locale="pt-BR"
            >
              <template v-slot:item="props">
                <tr @dblclick="openform(props.item.id)">
                  <td class="text-left">{{props.item.id}}</td>
                  <td class="text-left">{{props.item.dtfatal }}</td>
                  <td class="text-left">{{props.item.numero }}</td>
                  <td class="text-left">{{props.item.reclamante }}</td>
                  <td class="text-left">{{props.item.reclamada }}</td>
                  <td class="text-left">{{props.item.tipo }}</td>
                  <td class="text-left">{{props.item.status }}</td>
                </tr>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >Sua Pesquisa por "{{ searchAtrasados }}" não encontrou registros.</v-alert>
            </v-data-table>
          </v-tab-item>
          <v-tab-item key="2" value="tabHoje">
            <v-card-title>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-text-field v-model="searchHoje" append-icon="mdi-magnify" label="Pesquisar"></v-text-field>
            </v-card-title>
            <v-data-table :headers="headers" :items="itemsHoje" :search="searchHoje" locale="pt-BR">
              <template v-slot:item="props">
                <tr @dblclick="openform(props.item.id)">
                  <td class="text-left">{{props.item.id}}</td>
                  <td class="text-left">{{props.item.dtfatal }}</td>
                  <td class="text-left">{{props.item.numero }}</td>
                  <td class="text-left">{{props.item.reclamante }}</td>
                  <td class="text-left">{{props.item.reclamada }}</td>
                  <td class="text-left">{{props.item.tipo }}</td>
                  <td class="text-left">{{props.item.status }}</td>
                </tr>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >Sua Pesquisa por "{{ searchHoje }}" não encontrou registros.</v-alert>
            </v-data-table>
          </v-tab-item>
          <v-tab-item key="3" value="tabAmanha">
            <v-card-title>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-text-field v-model="searchAmanha" append-icon="mdi-magnify" label="Pesquisar"></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="itemsAmanha"
              :search="searchAmanha"
              locale="pt-BR"
            >
              <template v-slot:item="props">
                <tr @dblclick="openform(props.item.id)">
                  <td class="text-left">{{props.item.id}}</td>
                  <td class="text-left">{{props.item.dtfatal }}</td>
                  <td class="text-left">{{props.item.numero }}</td>
                  <td class="text-left">{{props.item.reclamante }}</td>
                  <td class="text-left">{{props.item.reclamada }}</td>
                  <td class="text-left">{{props.item.tipo }}</td>
                  <td class="text-left">{{props.item.status }}</td>
                </tr>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >Sua Pesquisa por "{{ searchAmanha }}" não encontrou registros.</v-alert>
            </v-data-table>
          </v-tab-item>
          <v-tab-item key="4" value="tabFuturos">
            <v-card-title>
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-text-field v-model="searchFuturos" append-icon="mdi-magnify" label="Pesquisar"></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="itemsFuturos"
              :search="searchFuturos"
              locale="pt-BR"
            >
              <template v-slot:item="props">
                <tr @dblclick="openform(props.item.id)">
                  <td class="text-left">{{props.item.id}}</td>
                  <td class="text-left">{{props.item.dtfatal }}</td>
                  <td class="text-left">{{props.item.numero }}</td>
                  <td class="text-left">{{props.item.reclamante }}</td>
                  <td class="text-left">{{props.item.reclamada }}</td>
                  <td class="text-left">{{props.item.tipo }}</td>
                  <td class="text-left">{{props.item.status }}</td>
                </tr>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >Sua Pesquisa por "{{ searchFuturos }}" não encontrou registros.</v-alert>
            </v-data-table>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </Formulario>
  </LayoutSite>
</template>

<script>
import LayoutSite from "@/components/layout/LayoutSite";
import Formulario from "@/components/Form";

export default {
  data() {
    return {
      Mensagem: "",
      tab: "tabHoje",
      searchAtrasados: "",
      searchHoje: "",
      searchAmanha: "",
      searchFuturos: "",
      headers: [
        { text: "ID", value: "id" },
        { text: "Data Fatal", value: "datafatal" },
        { text: "Nº Processo", value: "numero" },
        { text: "Reclamante", value: "reclamante" },
        { text: "Reclamada", value: "reclamada" },
        { text: "Tipo", value: "tipo" },
        { text: "Status", value: "status" }
      ],
      itemsAtrasados: [],
      itemsHoje: [],
      itemsAmanha: [],
      itemsFuturos: [],
      usuarios: [],
      isAdmin: false,
      responsavel_id: 0,
      Distribuicao: {
        Atrasados: 0,
        Hoje: 0,
        Amanha: 0,
        Futuros: 0
      }
    };
  },
  components: {
    LayoutSite,
    Formulario
  },
  created() {
    let usuario = this.$store.getters.getUsuario;

    if (usuario) {
      this.Mensagem = "Olá " + usuario.name + " !";
      this.responsavel_id = usuario.id;
      let permAux = this.$store.getters.getPermissoes;

      if (permAux) {
        if (permAux.ativo) {
          this.permissoes = permAux;
          if (!this.permissoes.prazo) this.$router.push("/#");
        } else this.$router.push("/#");
      } else this.$router.push("/#");

      this.$http
        .get(this.$urlAPI + "/usuario", {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => (this.usuarios = response.data));

      this.isAdmin = permAux.admin;

      this.Pesquisar();
    } else this.$router.push("/#");
  },
  watch: {
    responsavel_id(val) {
      this.Pesquisar();
    }
  },
  methods: {
    Pesquisar() {
      this.tab = "tabHoje";
      this.$http
        .get(this.$urlAPI + "/dashboard/" + this.responsavel_id, {
          headers: { authorization: "Bearer " + this.$store.getters.getToken }
        })
        .then(response => {
          this.Limpar();
          this.itemsAtrasados = response.data.Atrasados;
          this.itemsHoje = response.data.Hoje;
          this.itemsAmanha = response.data.Amanha;
          this.itemsFuturos = response.data.Futuros;
        });
    },
    Limpar() {
      this.itemsAtrasados = [];
      this.itemsHoje = [];
      this.itemsAmanha = [];
      this.itemsFuturos = [];
    },
    openform: function(id) {
      this.$router.push("/prazo/" + id);
    }
  }
};
</script>
